import styled from 'styled-components';
import Status from '../../../shared-components/elements/status/Status';
import {Icon} from '../Icon/Icon';
import {AnchorLink} from '../button/btn-type/AnchorLink';
import {Btn} from '../button/btn-type/Btn';

export const TableModifier = styled.table`
    tr td,
    tr th {
        ${Icon.Wrapper} {
            padding: 0;
            display: unset;
            margin: 0 2px;
            svg {
                width: calc(var(--table-column-body-text-size) + 1px);
                height: calc(var(--table-column-body-text-size) + 2px);
            }
        }
        ${Status} {
            --status-horizontal-padding: 9px;
            border-radius: 3px !important;
            padding: 1px var(--status-horizontal-padding) 2px !important;
            display: inline-flex;
            gap: 3px;
            font-size: calc(var(--table-column-body-text-size) - 1px);
            position: relative;
            left: calc(0px - var(--status-horizontal-padding));
            ${Icon.Wrapper} {
                padding: 0 0 0 -3px;
                display: unset;
                margin: 0 0 0 -2px;
                svg {
                    width: calc(var(--table-column-body-text-size) - 1px);
                    height: calc(var(--table-column-body-text-size) - 1px);
                    padding-bottom: 1px;
                }
            }
        }

        ${Btn},
        ${AnchorLink} {
            line-height: var(--table-column-body-text-size);
            font-size: var(--table-column-body-text-size);
            border-radius: 3px;
            min-height: unset;
        }
    }
`;
